function Logger() {
  let queryParams = window.queryParams || {};
  let featureFlag = 'logger';
  let isLoggerOn = featureFlag in queryParams && queryParams[featureFlag] == 'true';

  this.debug = message => isLoggerOn && console.debug(message);
  this.error = message => isLoggerOn && console.error(message);
  this.log = message => isLoggerOn && console.log(message);
}

module.exports = new Logger();
